module.exports = __webpack_public_path__ + "img/29-None.235c93ff.png";